import React from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';
import { MBTextStyles, UnvalidatedStyles } from './styles';

export type MBTextSize = 'tiny' | 'small' | 'normal' | 'large' | 'xlarge';

export interface MBTextProps {
  /*
        Center align the text

        TODO(fant): deprecate this in favour of align="center" ?
    */
  center?: boolean;

  /*
        Text alignment
    */
  align?: 'left' | 'center' | 'right';

  /*
        Makes the text bold. Default is false.
    */
  bold?: boolean;

  /*
        Makes the text light. Default is false.
        TODO(fant): do we want to move over to something
        like weight ('bold' | 'light' | 'normal') ?
    */
  light?: boolean;

  /*
        Makes the text italic
    */
  italic?: boolean;

  /*
        Makes a line appear through the text.
    */
  lineThrough?: boolean;

  /*
        Text size
        TODO(fant): standardize and sync this with Miwa
    */
  size?: MBTextSize;

  /*
        Text color. Default is dark gray (almost black)
    */
  color?: string;

  /*
        Number of lines the text occupies
    */
  numberOfLines?: number;

  /*
        Determines if the "..." ellipsis should be at the
        start (head), end (tail) or middle of the string
    */
  ellipsizeMode?: 'head' | 'tail' | 'middle';

  style?: StyleProp<TextStyle>;
  children: React.ReactNode | string;

  nativeId?: string;

  onPress?: () => void;
  testID?: string;

  /*
   Class name for web. Use by targeting data-class in CSS.
  */
  webClassName?: string;
}

export function MBText({
  children,
  center,
  align,
  bold,
  light,
  italic,
  style,
  numberOfLines,
  ellipsizeMode,
  onPress,
  color,
  lineThrough,
  nativeId,
  size = 'normal',
  testID,
  webClassName,
}: MBTextProps) {
  return (
    <Text
      onPress={onPress}
      numberOfLines={numberOfLines}
      ellipsizeMode={ellipsizeMode}
      nativeID={nativeId}
      style={[
        MBTextStyles.default,
        !!numberOfLines && UnvalidatedStyles.numberOfLines(numberOfLines),
        light && MBTextStyles.light,
        bold && MBTextStyles.bold,
        italic && MBTextStyles.italic,
        center && MBTextStyles.center,
        lineThrough && MBTextStyles.lineThrough,
        size === 'tiny' && MBTextStyles.sizeTiny,
        size === 'small' && MBTextStyles.sizeSmall,
        size === 'normal' && MBTextStyles.sizeNormal,
        size === 'large' && MBTextStyles.sizeLarge,
        size === 'xlarge' && MBTextStyles.sizeXLarge,
        !!color && { color },
        !!align && { textAlign: align },
        style,
      ]}
      testID={testID}
      // @ts-ignore
      dataSet={{ class: webClassName }}
    >
      {children}
    </Text>
  );
}
